module.exports = __webpack_public_path__ + "static/media/05.6dc29950.jpg";